/**
 * Modèle or offline — serveur importe ce fichier (.mjs) ; client : `offline_gold_model.ts`.
 * Constantes session : sync avec `offline_constants.ts`.
 */
const OFFLINE_BASE_IDLE_RATIO_LOGOUT = 1;
const OFFLINE_BASE_IDLE_RATIO_ESTIMATED = 1;
const OFFLINE_SHOP_CHANNEL_BONUS_MAX_PCT = 15;

/** @deprecated Ancien bonus taux — migré vers puissance or */
export const LEGACY_OFFLINE_EFFICIENCY_MAX_BONUS_PCT = 12;

export const OFFLINE_GOLD_POWER_STEP_PCT = 5;
export const OFFLINE_GOLD_POWER_MAX_PCT = 50;

export const OFFLINE_GOLD_POWER_UPGRADE_COSTS = [
  40, 70, 110, 160, 220, 35, 65, 110, 160, 220,
];

export function offlineSessionBaseRatio(sessionConnected) {
  return sessionConnected
    ? OFFLINE_BASE_IDLE_RATIO_LOGOUT
    : OFFLINE_BASE_IDLE_RATIO_ESTIMATED;
}

export function migrateLegacyGoldPowerPct(efficiencyBonusPct, goldCapBonusPct) {
  const eff = Math.max(
    0,
    Math.min(
      LEGACY_OFFLINE_EFFICIENCY_MAX_BONUS_PCT,
      Math.floor(efficiencyBonusPct),
    ),
  );
  const cap = Math.max(
    0,
    Math.min(OFFLINE_SHOP_CHANNEL_BONUS_MAX_PCT, Math.floor(goldCapBonusPct)),
  );
  const legacyCapMult =
    (OFFLINE_BASE_IDLE_RATIO_LOGOUT + eff / 100) * (1 + cap / 100);
  const power = Math.round(
    100 * (legacyCapMult / OFFLINE_BASE_IDLE_RATIO_LOGOUT - 1) + 1e-9,
  );
  return Math.max(0, Math.min(OFFLINE_GOLD_POWER_MAX_PCT, power));
}

export function resolveOfflineGoldPowerPct(
  goldPowerPct,
  efficiencyBonusPct,
  goldCapBonusPct,
) {
  if (goldPowerPct !== undefined && Number.isFinite(goldPowerPct)) {
    return Math.max(
      0,
      Math.min(OFFLINE_GOLD_POWER_MAX_PCT, Math.floor(goldPowerPct)),
    );
  }
  return migrateLegacyGoldPowerPct(efficiencyBonusPct, goldCapBonusPct);
}

export function computeOfflineGoldCapPerHour(
  progressionAnchorPerHour,
  sessionConnected,
  goldPowerPct,
) {
  const baseRatio = offlineSessionBaseRatio(sessionConnected);
  const power = Math.max(
    0,
    Math.min(OFFLINE_GOLD_POWER_MAX_PCT, Math.floor(goldPowerPct)),
  );
  return Math.floor(progressionAnchorPerHour * baseRatio * (1 + power / 100));
}

export function nextGoldPowerUpgradeCost(currentPowerPct) {
  if (currentPowerPct >= OFFLINE_GOLD_POWER_MAX_PCT) return null;
  const stepIndex = Math.floor(currentPowerPct / OFFLINE_GOLD_POWER_STEP_PCT);
  return OFFLINE_GOLD_POWER_UPGRADE_COSTS[stepIndex] ?? null;
}

export function countGoldPowerTiers(goldPowerPct) {
  const total = Math.floor(
    OFFLINE_GOLD_POWER_MAX_PCT / OFFLINE_GOLD_POWER_STEP_PCT,
  );
  const filled = Math.min(
    total,
    Math.ceil(goldPowerPct / OFFLINE_GOLD_POWER_STEP_PCT),
  );
  return { filled, total };
}
